
var sprite = require("C:/git/annenberg-petspace-petbook/node_modules/svg-sprite-loader/lib/web/global-sprite");
var image = "<symbol viewBox=\"0 0 21.98 20.14\" id=\"home\" ><title>Asset 3</title><g fill=\"#fff\" data-name=\"Layer 2\"><path d=\"M.75 8.08A.75.75 0 0 1 .36 6.7L11.17 0l10.46 6.7a.75.75 0 0 1-.81 1.3l-9.67-6.23L1.14 8a.74.74 0 0 1-.39.08z\"/><path d=\"M11.14 3.92L2.72 8.83v11.31H8v-6.59a3 3 0 0 1 6 0v6.59h5.26V8.83z\"/></g></symbol>";
module.exports = sprite.add(image, "home");


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/home.svg
// module id = 304
// module chunks = 1